function storeChanged(event, callback) {
	const oldAddress = findSelectedAddress(
		event.oldValue[event.oldValue.length - 1],
	);
	const newAddress = findSelectedAddress(event.newValue);

	if (
		(oldAddress && oldAddress.id) !== (newAddress && newAddress.id) &&
		typeof callback === 'function'
	) {
		callback(event.newValue);
	} else if (
		(oldAddress && oldAddress.id) !== (newAddress && newAddress.id) &&
		callback instanceof Array
	) {
		callback.forEach(cb => cb(event.newValue));
	}
}

function findSelectedAddress(addressList) {
	return addressList instanceof Array
		? addressList.find(address => address.selected)
		: null;
}

export { storeChanged, findSelectedAddress };
